<template>
  <div style="background-color: #F6F6F6; position: relative;overflow-x: hidden">
    <van-nav-bar @click-left="onClickLeft" :border="false">
    <span slot="left" style="font-size: 17px">
       <van-icon color="black" name="arrow-left"></van-icon>
    </span>
    <span @click="isDel = !isDel" slot="right" style="font-size: 14px;color: #2B2D2F">
       {{isDel ? '取消' : '编辑'}}
    </span>
    <span slot="title" style="font-size: 17px;color: #505050;font-weight: bold">购物车</span>
    </van-nav-bar>
    <div style="background: #F6F7F8; height: calc(100vh - 54px - 40vw);overflow-y: auto; padding-bottom: 40vw">
      <div style="padding-top: 8.53vw;background: white">
        <div
          v-for="item in buyCars"
          :key="item.goodsId"
          style="background-color: white;overflow: hidden;padding-bottom: 5.2vw;position: relative"
        >
          <div v-if="item.goodsName" class="nBuyCartItem">
            <van-swipe-cell>
              <div style="display: flex;position: relative">
                <div style="flex: 1;margin-right: 4vw;height: 19.2vw;" class="centerBox">
                  <van-checkbox @click="changeShopItem" v-model="item.checked" checked-color="#DA3939"  icon-size="14"></van-checkbox>
                </div>
                <my-shop-list @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)" @expend="changeExpend" :source="source" :min="0" :row="item" @plus="changeCartGoodsNum(item, 1)" @minus="changeCartGoodsNum(item, 2)"></my-shop-list>
              </div>
<!--              <template slot="right">-->
<!--                <van-button square type="danger" class="cartDeleteButton">-->
<!--                  <div style="margin-top: .8vw;font-size: 3.2vw">删除</div>-->
<!--                </van-button>-->
<!--              </template>-->
            </van-swipe-cell>
          </div>
          <div v-if="item.containerLoadName" class="nBuyCartItem">
            <van-swipe-cell>
              <div style="display: flex;position: relative;">
                <div style="flex: 1;margin-right: 4vw;height: 19.2vw;" class="centerBox">
                  <van-checkbox @click="changeShopItem" v-model="item.checked" checked-color="#DA3939"  icon-size="14"></van-checkbox>
                </div>
                <p-list @plusTwo2="addPinSecorend(arguments)" @minusTwo2="jjPinSecorend(arguments)" @expend="changeExpend" :row="item"></p-list>
              </div>
            </van-swipe-cell>
          </div>
        </div>
      </div>
    </div>
    <div class="buyCartEnd">
      <div style="display: flex">
        <van-checkbox v-model="bottomInfo.selectAll" checked-color="#DA3939" @click="onAllCheck()" icon-size="14" style="margin-left: 4vw">
          <div style="font-size: 3.2vw;color: #484848;">全选</div>
        </van-checkbox>
      </div>
      <div class="centerBox">
        <div v-show="!isDel" style="margin-right: 4.27vw;font-family: din-bold;">
          <div style="margin: 0;color: black; font-size: 3.73vw">合计:<div style="display: inline-block; margin-top: .4vw;font-size: 2.4vw;transform: translateY(.3vw)">￥<span style="font-size: 4vw">{{$utils.priceFormat(bottomInfo.selectPrice)}}</span></div></div>
        </div>
        <van-button type="danger" color="#DA3939" :disabled="!bottomInfo.selectQty" @click.stop="onSubmit" style="margin-right: 4.13vw;width: auto;height: 9.07vw; font-size: 3.73vw;padding: 0 4.67vw" round :plain="isDel">
          <div style="">{{(isDel ? '删除' : '结算') + (bottomInfo.selectQty ? '(' + bottomInfo.selectQty + ')' : '')}}</div>
        </van-button>
      </div>
    </div>
    <van-dialog v-model="show2" @confirm = confirmClick() @cancel = cencel() title="标题" show-cancel-button>
      <van-field
        v-model="remark"
        rows="1"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入备注"
      />
    </van-dialog>
    <van-popup v-model="showPopup">
      <div style="padding: 5.1vw 0 3.4vw;width:60vw;text-align: center">
        <div style="color: #333333;font-size: 3.4vw;margin-bottom: 6.3vw;">订单已提交, 正在审核中</div>
        <img src="../../../assets/img/confirmOrder.png" style="width: 35.3vw;margin-bottom: 6.8vw">
        <div @click="showPopup = false, $router.push('/myMenu/shopSearch')" style="background: #de3a3a;font-size: 2.9vw;border-radius: .5vw;color: white;height: 7vw;width: 23.9vw;margin: 0 auto" class="centerBox">
          继续挑选
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { extendDefaults } from 'swiper'

// import html2canvas from 'html2canvas'
export default {
  name: 'buyCart',
  data () {
    return {
      source: 1,
      remark: '',
      showPopup: false,
      show2: false,
      buyCars: [],
      AllCheck: false,
      isDel: false,
      infoShow: false,
      showShare: false,
      show: false,
      levelUpShow: false,
      code: '',
      imgUrl: '',
      codeImg: '',
      bottomInfo: {
        selectAll: false,
        selectQty: 0,
        selectPrice: 0
      },
      imgObj: {
        stores: [{
          goods: [{
            imgPath: '',
            goodsName: ''
          }]
        }]
      },
      orderNo: '',
      specificationCategory:'',
      specificationMiniBuyQty:'',
      commercialSpecificationFlag:'',
      userObj: {},
      shareOptions: [
        // { name: '微信', icon: 'wechat' },
        {
          name: '复制链接',
          icon: 'link',
          id: 1
        },
        {
          name: '生成图片二维码',
          icon: 'qrcode',
          id: 2
        }
      ]
    }
  },
  components: {
    // html2canvas
  },
  created () {
    this.selectCarts()
    // this.userInfo()
    // this.showMember3()
  },
  destroyed () {
    this.$toast.clear()
  },
  methods: {
    confirmClick () {
      this.$toast.loading({
        duration: 0
      })
      const orderItemList = []
      console.log("this.buyCars",this.buyCars);
      this.buyCars.forEach(item => {
        if (item.checked && item.goodsName) {
          orderItemList.push({
            goodsId: item.goodsId,
            goodsName: item.goodsName,
            goodsPrice: item.price,
            qty: item.qty,//以前是没传的
            specificationCategory: item.specificationCategory,
            specificationMiniBuyQty: item.specificationMiniBuyQty,
            commercialSpecificationFlag: item.commercialSpecificationFlag,
          })
        } else if (item.checked && item.containerLoadGoodsList) {
          console.log(item)
          if (item.containerLoadGoodsList.length > 0) {
            console.log(item)
            item.containerLoadGoodsList.forEach(item2 => {
              if (item2.qty) {
                orderItemList.push({
                  goodsId: item2.goodsId,
                  goodsName: item2.goodsName,
                  containerLoadId: item2.containerLoadId,
                  goodsPrice: item2.price,
                  qty: item2.qty,
                  specificationCategory: item.specificationCategory,
                  specificationMiniBuyQty: item.specificationMiniBuyQty,
                  commercialSpecificationFlag: item.commercialSpecificationFlag,
                })
              }
            })
          }
        }
      })
      // let len = orderItemList.length
      // for (let i = 0; i < len; i++) {
      //   for (let j = i + 1; j < len; j++) {
      //     if (orderItemList[i].goodsName === orderItemList[j].goodsName) {
      //       console.log(1)
      //       orderItemList[i].qty += orderItemList[j].qty
      //       orderItemList.splice(j, 1) // arr删除重复元素
      //       len--
      //       j-- // 每删除一个数j的值就减1
      //     }
      //   }
      // }

      this.$request.shopCar.createOrder({
        remark: this.remark,
        orderItemList,
        orderPrice: this.bottomInfo.selectPrice
      })
        .then((response) => {
          if (response.code === '200') {
            this.$toast.clear()
            this.selectCarts()
            this.showPopup = true
            this.remark = ''
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })


      // this.$dialog.confirm({
      //     message: '确认要提交订单吗'
      //   }).then(() => {
      //     this.$toast.loading({
      //       duration: 0
      //     })
      //     const orderItemList = []
      //     this.buyCars.forEach(item => {
      //       if (item.checked && item.goodsName) {
      //         orderItemList.push({
      //           goodsId: item.goodsId,
      //           goodsName: item.goodsName,
      //           goodsPrice: item.price,
      //           qty: item.buyQty
      //         })
      //       } else if (item.checked && item.containerLoadGoodsList) {
      //         console.log(item)
      //         if (item.containerLoadGoodsList.length > 0) {
      //           console.log(item)
      //           item.containerLoadGoodsList.forEach(item2 => {
      //             if (item2.qty) {
      //               orderItemList.push({
      //                 goodsId: item2.goodsId,
      //                 goodsName: item2.goodsName,
      //                 containerLoadId: item2.containerLoadId,
      //                 goodsPrice: item2.price,
      //                 qty: item2.qty
      //               })
      //             }
      //           })
      //         }
      //       }
      //     })
      //     // let len = orderItemList.length
      //     // for (let i = 0; i < len; i++) {
      //     //   for (let j = i + 1; j < len; j++) {
      //     //     if (orderItemList[i].goodsName === orderItemList[j].goodsName) {
      //     //       console.log(1)
      //     //       orderItemList[i].qty += orderItemList[j].qty
      //     //       orderItemList.splice(j, 1) // arr删除重复元素
      //     //       len--
      //     //       j-- // 每删除一个数j的值就减1
      //     //     }
      //     //   }
      //     // }
        console.log("orderItemList",orderItemList);
      //     this.$request.shopCar.createOrder({
      //       orderItemList,
      //       orderPrice: this.bottomInfo.selectPrice,
      //       remark: ''
      //     })
      //       .then((response) => {
      //         if (response.code === '200') {
      //           this.$toast.clear()
      //           this.selectCarts()
      //           this.showPopup = true
      //         } else {
      //           this.$toast(response.msg)
      //         }
      //       })
      //       .catch((error) => {
      //         console.log(error)
      //       })
      //   })
    },
    cencel () {
      this.show2 = false
      this.remark = ''
    },
    // 第二次增加拼箱
    addPinSecorend (data) {
      console.log(data[0]) // 里面
      console.log(data[1]) // 外面
      this.$toast.loading({
        duration: 0
      })
      const containerLoadGoodsList = []
      if (data[0]) {
        containerLoadGoodsList.push({
          category: data[0].category,
          goodsId: data[0].goodsId,
          qty: data[0].miniBuyQty,
          opFlag: 1
        })
      }
      this.$request.shop.changeCartGoodsNum2({
        category: data[0].category,
        opFlag: 0,
        containerLoadName: data[1].containerLoadName,
        miniBuyQty: data[1].miniBuyQty,
        containerLoadGoodsList: containerLoadGoodsList
      })
        .then((response) => {
          if (response.code === '200') {
            this.selectCarts2()
              .then(res => {
                this.changeShopItem()
              })
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 第二次减少拼箱
    jjPinSecorend (data) {
      if (!data[0].qty) {
        this.addCart(data[0])
        return
      }
      this.$toast.loading({
        duration: 0
      })
      const containerLoadGoodsList = []
      if (data[0]) {
        containerLoadGoodsList.push({
          category: data[0].category,
          goodsId: data[0].goodsId,
          qty: data[0].miniBuyQty,
          opFlag: 2
        })
      }
      this.$request.shop.changeCartGoodsNum2({
        category: data[0].category,
        opFlag: 0,
        containerLoadName: data[1].containerLoadName,
        miniBuyQty: data[1].miniBuyQty,
        containerLoadGoodsList: containerLoadGoodsList
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.selectCarts2()
              .then(res => {
                this.changeShopItem()
              })
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toLevelUp () {
      this.$router.push({
        path: '/myMenu/mine',
        query: {
          levelUp: 1
        }
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    cancleLevelUp () {
      this.$request.shop.editUpGradeKnow()
      this.levelUpShow = false
    },
    userInfo () {
      const self = this
      self.$request.mineMessage.userInfo()
        .then((response) => {
          self.userObj = response.data
        })
    },
    deleteCartOne (item) {
      this.$dialog.confirm({
        message: `确认要删除商品"${item.goodsName}"吗`
      }).then(() => {
        this.$toast.loading({
          duration: 0
        })
        this.$request.buyCart.deleteCartOne(item)
          .then((response) => {
            this.selectCarts()
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    // 选中算数
    changeShopItem () {
      this.bottomInfo.selectPrice = 0
      this.bottomInfo.selectQty = 0
      this.buyCars.forEach(item => {
        if (item.checked) {
          console.log(item)
          this.bottomInfo.selectQty++
          this.bottomInfo.selectPrice += item.unitPrice * item.buyQty
          if (item.containerLoadGoodsList) {
            if (item.containerLoadGoodsList.length > 0) {
              item.containerLoadGoodsList.forEach(item2 => {
                this.bottomInfo.selectPrice += item2.unitPrice * item2.qty
              })
            }
          }
        }
      })
      console.log(this.bottomInfo.selectPrice)
      this.bottomInfo.selectAll = this.bottomInfo.selectQty === this.buyCars.length
      // console.log(this.bottomInfo.selectQty, '1')
      // console.log(this.buyCars.length, '2')
    },
    // 选中算钱
    onAllCheck (value) {
      // eslint-disable-next-line eqeqeq
      if (this.bottomInfo.selectQty != this.buyCars.length) {
        this.bottomInfo.selectQty = 0
        this.bottomInfo.selectPrice = 0
        this.buyCars.forEach(item => {
          item.checked = true
          this.bottomInfo.selectQty++
          this.bottomInfo.selectPrice += item.unitPrice * item.buyQty
          if (item.containerLoadGoodsList) {
            if (item.containerLoadGoodsList.length) {
              if (item.containerLoadGoodsList.length > 0) {
                item.containerLoadGoodsList.forEach(item2 => {
                  this.bottomInfo.selectPrice += item2.unitPrice * item2.qty
                })
              }
            }
          }
        })
      } else {
        this.bottomInfo.selectQty = 0
        this.bottomInfo.selectPrice = 0
        this.buyCars.forEach(item => {
          item.checked = false
        })
      }
    },
    toInfo (id) {
      this.$router.push({ name: 'ShopInfo', query: { id } })
    },
    onSubmit () {
      if (this.isDel) {
        this.deleteCart()
      } else {
        this.createOrder()
      }
    },
    deleteCart () {
      this.$dialog.confirm({
        message: '确认要删除选中的商品吗'
      }).then(() => {
        this.$toast.loading({
          duration: 0
        })
        const orderItemList = []
        this.buyCars.forEach(item => {
          if (item.checked) {
            orderItemList.push({
              containerLoadName: item.containerLoadName,
              goodsId: item.goodsId,
              goodsName: item.goodsName,
              goodsPrice: item.price,
              qty: item.buyQty
            })
          }
        })
        this.$request.shop.delCartGoods(orderItemList)
          .then((response) => {
            this.selectCarts()
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    // 结算
    createOrder () {
      // 主list
      const Zplist = []
      // 拼箱list
      const Pxlist = []
      this.buyCars.forEach(item => {
        // 买普通单品
        if (item.containerLoadGoodsList) {
          if (item.containerLoadGoodsList.length > 0) {
            Pxlist.push(item)
          }
        } else {
          Zplist.push(item)
        }
      })
      // let a = 1
      // if (Zplist.length > 0) {
      //   let max = Zplist[0].miniBuyQty
      //   for (let i = 0; i < Zplist.length - 1; i++) {
      //     max = max < Zplist[i + 1].miniBuyQty ? Zplist[i + 1].miniBuyQty : max
      //   }
      //   let totol = 0
      //   Zplist.forEach(item => {
      //     totol += Number(item.buyQty)
      //   })
      //   console.log(max, '最小购买量')
      //   console.log(totol, '总数')
      //   if (totol % max === 0) {
      //     console.log('主品整除')
      //   } else {
      //     this.$toast('购买数必须大于件数')
      //     console.log('主品不整除')
      //     a--
      //   }
      // }
      // 主品校验通过
      // console.log(Pxlist)
      let b = 1
      if (Pxlist.length > 0) {
        Pxlist.forEach(item => {
          let Pqty = 0
          item.containerLoadGoodsList.forEach(item2 => {
            Pqty += item2.qty
          })
          if (Pqty % item.miniBuyQty === 0) {
            console.log('整除2')
            console.log("if",b);
            console.log("panduan",b);
      // if (b > 0) {
        // this.$request.shop.selOrderRemark()
        //   .then(res => {
        //     if (res.code === 200 || res.code === '200') {
        //       if (res.data) {
        //         this.remark = res.data
        //       } else {
        //         this.remark = ''
        //       }
        //       this.show2 = true
        //     }
        //   })
        //   .catch(error => {
        //     console.log(error)
        //   })
      // }
      // return false
          } else {
            this.$toast(item.containerLoadName + '未达到整箱')
            b--
            // this.remark = ''
            // this.show2 = false
            // this.cencel()
            console.log("else.b",b);
            console.log("this.show2.b",this.show2);
          }
   ////新增       if (Pqty % item.miniBuyQty !== 0) {
   ////新增         this.$toast(item.containerLoadName + '未达到整箱')
   ////新增         b--
   ////新增         // this.remark = ''
   ////新增         // this.show2 = false
   ////新增         console.log("else.b",b);
   ////新增         console.log("this.show2.b",this.show2);
   ////新增         this.cencel()
   ////新增         return false
   ////新增         
   ////新增       }
   ////新增       if (Pqty % item.miniBuyQty !== 0){
   ////新增         console.log('整除2')
   ////新增         console.log("if",b);
   ////新增         console.log("panduan",b);
   ////新增   // if (b > 0) {
   ////新增     this.$request.shop.selOrderRemark()
   ////新增       .then(res => {
   ////新增         if (res.code === 200 || res.code === '200') {
   ////新增           if (res.data) {
   ////新增             this.remark = res.data
   ////新增           } else {
   ////新增             this.remark = ''
   ////新增           }
   ////新增           this.show2 = true
   ////新增         }
   ////新增       })
   ////新增       .catch(error => {
   ////新增         console.log(error)
   ////新增       })
   ////新增       }
        })
    }


      // 当前时间戳
      // const data = new Date().getTime() + ''
      // if (data > window.localStorage.getItem('orderStartTime') && data < window.localStorage.getItem('orderEndTime')) {
      // } else {
      //   this.$toast('未在下单时间范围内')
      //   b--
      // }
      // a === 0

      // console.log("panduan",b);
      if (b > 0) {
        this.$request.shop.selOrderRemark()
          .then(res => {
            if (res.code === 200 || res.code === '200') {
              if (res.data) {
                this.remark = res.data
              } else {
                this.remark = ''
              }
              this.show2 = true
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // 第二次添加
    changeCartGoodsNum (children, type) {
      console.log(children)
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.changeCartGoodsNum({
        miniBuyQty: children.miniBuyQty,
        goodsId: children.goodsId,
        category: children.category,
        opFlag: type
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            // console.log(this.bottomInfo.selectAll)
            this.selectCarts2()
              .then(res => {
                this.changeShopItem()
              })
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeExpend (item) {
      // console.log(item)
      item.show = !item.show
    },
    changeCartGoodsNumTwo (data) {
      this.$toast.loading({
        duration: 0
      })
      // console.log(data)
      const minCartGoodsList = []
      if (data[0]) {
        minCartGoodsList.push({
          category: data[0].category,
          goodsId: data[0].goodsId,
          opFlag: 1
        })
      }
      this.$request.shop.changeCartGoodsNum({
        ...data[1],
        goodsId: data[1].goodsId,
        opFlag: 0,
        minCartGoodsList: minCartGoodsList
      })
        .then((response) => {
          this.$toast.clear()
          this.selectCarts2()
            .then(res => {
              this.changeShopItem()
            })
          // this.selectCategory()
          // if (response.code === '200') {
          //   this.selectCarts()
          // } else {
          //   this.$toast(response.msg)
          // }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    minusCartGoodsNumTwo (data) {
      console.log(data)
      this.$toast.loading({
        duration: 0
      })
      // console.log(data[0])
      const minCartGoodsList = []
      if (data[0]) {
        minCartGoodsList.push({
          category: data[0].category,
          goodsId: data[0].goodsId,
          opFlag: 2
        })
      }
      this.$request.shop.changeCartGoodsNum({
        ...data[0],
        goodsId: data[0].goodsId,
        opFlag: 0,
        minCartGoodsList: minCartGoodsList
      })
        .then((response) => {
          this.$toast.clear()
          this.selectCarts2()
            .then(res => {
              this.changeShopItem()
            })
          // this.selectCategory()
          // if (response.code === '200') {
          //   this.selectCarts()
          // } else {
          //   this.$toast(response.msg)
          // }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    selectCarts2 () {
      return new Promise(resolve => {
        this.$toast.loading({
          duration: 0
        })
        this.$request.shop.shopCartList()
          .then((response) => {
            response.data.forEach(item => {
              this.$set(item, 'show', false)
              this.$set(item, 'commercialSpecificationFlag', '2')
              this.$set(item, 'specificationCategory', item.category)
              this.$set(item, 'specificationMiniBuyQty',item.miniBuyQty)

              if (item.minCartGoodsList) {
                if (item.minCartGoodsList.length > 0) {
                  item.show = true
                }
              }
              if (item.containerLoadGoodsList) {
                if (item.containerLoadGoodsList.length > 0) {
                  item.show = true
                item.commercialSpecificationFlag = '2'
                }
              }else{
              item.commercialSpecificationFlag = '1'
            }
            })
            this.buyCars = response.data
            this.buyCars.forEach((item, index) => {
              this.$set(this.buyCars[index], 'checked', true)
              this.$set(this.buyCars[index], 'buyQty', item.qty)
            })
            if (this.buyCars.length) {
              this.bottomInfo.selectAll = true
            }
            // this.onAllCheck()
            resolve(response)
            this.$toast.clear()
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },
    selectCarts () {
      console.log(1)
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.shopCartList()
        .then((response) => {
          this.specificationMiniBuyQty = response.data.miniBuyQty
          this.specificationCategory = response.data.category
          
          response.data.forEach(item => {
            this.$set(item, 'show', false)
            this.$set(item, 'commercialSpecificationFlag', '2')
            this.$set(item, 'specificationCategory', item.category)
              this.$set(item, 'specificationMiniBuyQty', item.miniBuyQty)
            if (item.minCartGoodsList) {
              if (item.minCartGoodsList.length > 0) {
                item.show = true
              }
            }
            if (item.containerLoadGoodsList) {
              if (item.containerLoadGoodsList.length > 0) {
                item.show = true
                item.commercialSpecificationFlag = '2'
              }
            }else{
              item.commercialSpecificationFlag = '1'
            }
          })
          this.buyCars = response.data
          this.buyCars.forEach((item, index) => {
            this.$set(this.buyCars[index], 'checked', true)
            this.$set(this.buyCars[index], 'buyQty', item.qty)
          })
          if (this.buyCars.length) {
            this.bottomInfo.selectAll = true
          }
          // if (response.data.containerLoadGoodsList.length > 0) {
          //   this.commercialSpecificationFlag = '2'
          // }else {
          //   this.commercialSpecificationFlag = '1'
          // }
          // console.log("commercialSpecificationFlag",this.commercialSpecificationFlag);
          console.log(response.data);
          this.onAllCheck()
          this.$toast.clear()
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
  .cartDeleteButton {
    height: 100%;
    background: linear-gradient(0deg, #FA3018, #FA3018, #FA5D19);
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 120px;
    height: 120px;
    background-color: red;
  }
</style>
